"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ConditionsPicker = _interopRequireDefault(require("./ConditionsPicker"));
var _cccisdFormik = require("cccisd-formik");
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ConditionsRow = function ConditionsRow(_ref) {
  var index = _ref.index,
    conditionsCount = _ref.conditionsCount,
    removeRow = _ref.removeRow,
    moveUp = _ref.moveUp,
    moveDown = _ref.moveDown;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].conditions
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "ifThen.conditions.".concat(index, ".condition"),
    DataConnectorsPicker: _ConditionsPicker["default"],
    component: _cccisdFormik.CccisdCondition,
    componentProps: {
      connectorName: 'Variable'
    },
    validate: _cccisdFormik.validateCccisdCondition
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6 ".concat(_style["default"].valueControls)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].value
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "ifThen.conditions.".concat(index, ".value"),
    component: _cccisdFormik.CccisdInput
  })), conditionsCount > 1 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].controls
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-danger ".concat(_style["default"].removeButton),
    onClick: function onClick() {
      return removeRow(index);
    },
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].udArrows
  }, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      return moveUp(index);
    },
    className: index === 0 ? _style["default"].disabled : null
  }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null)), /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      return moveDown(index);
    },
    className: conditionsCount === index + 1 ? _style["default"].disabled : null
  }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null))))));
};
ConditionsRow.propTypes = {
  index: _propTypes["default"].number,
  conditionsCount: _propTypes["default"].number,
  removeRow: _propTypes["default"].func,
  moveUp: _propTypes["default"].func,
  moveDown: _propTypes["default"].func
};
var _default = exports["default"] = ConditionsRow;